import { styled } from 'styled-system/jsx'

const SparklineSurface = styled('div', {
  base: {
    position: 'relative',
    width: '100%',
  },
})

const SparklineSvg = styled('svg', {
  base: {
    display: 'block',
    width: '100%',
    height: '100%',
    overflow: 'visible',
  },
})

const SparklinePath = styled('path', {
  base: {
    fill: 'none',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  },
  variants: {
    trend: {
      up: { stroke: 'quickpass.warmth' },
      down: { stroke: 'quickpass.success' },
      flat: { stroke: 'quickpass.primary' },
    },
  },
  defaultVariants: {
    trend: 'flat',
  },
})

const SparklineArea = styled('path', {
  base: {
    stroke: 'none',
    opacity: '0.18',
  },
  variants: {
    trend: {
      up: { fill: 'quickpass.warmth' },
      down: { fill: 'quickpass.success' },
      flat: { fill: 'quickpass.primary' },
    },
  },
  defaultVariants: {
    trend: 'flat',
  },
})

const Endpoint = styled('circle', {
  base: {
    strokeWidth: '2',
    stroke: '#FFFFFF',
  },
  variants: {
    trend: {
      up: { fill: 'quickpass.warmth' },
      down: { fill: 'quickpass.success' },
      flat: { fill: 'quickpass.primary' },
    },
  },
  defaultVariants: {
    trend: 'flat',
  },
})

const EmptyBlock = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    fontStyle: 'italic',
    paddingY: '14px',
  },
})

export {
  SparklineSurface,
  SparklineSvg,
  SparklinePath,
  SparklineArea,
  Endpoint,
  EmptyBlock,
}
